module.exports = __webpack_public_path__ + "static/media/en.a825e758.svg";